module.exports={shellWaitLabel:"Loading"};